import { Observable } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  constructor(private apiService: ApiService, private http: HttpClient) {}

  //LATITUDE getters, setters
  private _latitude: any;

  public get latitude(): any {
    return this._latitude;
  }

  public set latitude(value: any) {
    this._latitude = value;
  }

  //LONGITUDE getters, setters
  private _longitude: any;

  public get longitude(): any {
    return this._longitude;
  }

  public set longitude(value: any) {
    this._longitude = value;
  }

  createBooking(bookingInfo): Observable<any> {
    return this.apiService.post('bookings/create', bookingInfo);
  }

  updateBooking(bookingInfo): Observable<any> {
    return this.apiService.post('bookings/update', bookingInfo);
  }

  deleteBooking(id): Observable<any> {
    return this.apiService.delete(`bookings/delete/${id}`);
  }

  getMyBookings(): Observable<any> {
    if (this.isLocationStored()) {
      return this.apiService.get(`bookings/myBookings?lat=${this.latitude}&long=${this.longitude}`);
    } else {
      return this.apiService.get('bookings/myBookings');
    }
  }

  getBookingsListing(): Observable<any> {
    if (this.isLocationStored()) {
      return this.apiService.get(`bookings/listing?lat=${this.latitude}&long=${this.longitude}`);
    } else {
      return this.apiService.get('bookings/listing');
    }
  }

  getBookingDetails(id): Observable<any> {
    if (this.isLocationStored()) {
      return this.apiService.get(`bookings/getBookingDetails/${id}?lat=${this.latitude}&long=${this.longitude}`);
    } else {
      return this.apiService.get(`bookings/getBookingDetails/${id}`);
    }
  }

  getAccountTypesBooking(data): Observable<any> {
    if (this.isLocationStored()) {
      if (this.isUserLoggedIn())
        return this.apiService.post(`bookings/accountTypesBooking?lat=${this.latitude}&long=${this.longitude}`, data);
      else
        return this.http.post(environment.base_url + `bookings/accountTypesBooking?lat=${this.latitude}&long=${this.longitude}`, data);
    } else {
      if (this.isUserLoggedIn())
        return this.apiService.post('bookings/accountTypesBooking', data);
      else
        return this.http.post(environment.base_url + 'bookings/accountTypesBooking', data);
    }
  }

  getUserUpcomingBookings(data): Observable<any> {
    if (this.isLocationStored()) {
      return this.apiService.post(`bookings/userUpcomingBookings?lat=${this.latitude}&long=${this.longitude}`, data);
    } else {
      return this.apiService.post('bookings/userUpcomingBookings', data);
    }
  }

  bookNow(data): Observable<any> {
    return this.apiService.post('bookings/bookNow', data);
  }

  getStatusBookings(): Observable<any> {
    if (this.isLocationStored()) {
      return this.apiService.get(`bookings/getStatusBookings?lat=${this.latitude}&long=${this.longitude}`);
    } else {
      return this.apiService.get('bookings/getStatusBookings');
    }
  }

  changeRequestBookingStatus(data): Observable<any> {
    return this.apiService.post('bookings/changeRequestBookingStatus', data);
  }


  isUserLoggedIn(){
    const storage_data = JSON.parse(localStorage.getItem('user_data'));
    if (storage_data !== undefined && storage_data !== null) {
      return true;
    }else{
      return false;
    }
  }

  isLocationStored() {
    const location_storage = JSON.parse(sessionStorage.getItem('location'));
    if (location_storage !== undefined && location_storage !== null) {
      this.latitude = location_storage.latitude;
      this.longitude = location_storage.longitude;
      return true;
    } else {
      return false;
    }
  }

}
